import { createApi } from "@reduxjs/toolkit/query/react";
import { publicBaseQuery } from "./baseQueries";

export const callbackAPI = createApi({
  reducerPath: "callbackAPI",
  baseQuery: publicBaseQuery,
  endpoints: (build) => ({
    requestCallback: build.mutation({
      query: ({ values }) => ({
        url: `/api/public/call-back-request-email`,
        method: "POST",
        body: { ...values },
      }),
    }),
    getOtpCode: build.query({
      query: ({ phoneNumber, name }) => ({
        url: `/api/public/send-otp?phoneNo=${phoneNumber}&userName=${name}`,
      }),
    }),
    submitOtpCode: build.query({
      query: ({ phoneNumber, otp }) => ({
        url: `/api/public/verify-otp?phoneNo=${phoneNumber}&otp=${otp}`,
      }),
    }),
  }),
});

export const {
  useRequestCallbackMutation,
  useLazyGetOtpCodeQuery,
  useLazySubmitOtpCodeQuery,
} = callbackAPI;
